var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNotificationBlueInActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6811 15.3C18.4811 15.8 17.8811 16.2 17.3811 16.2H1.48114C0.981139 16.2 0.481139 15.9 0.181139 15.5C-0.118861 15 -0.0188612 14.5 0.281139 14L0.881139 13.1C1.88114 11.6 2.38114 9.9 2.38114 8.2V7.1C2.38114 3.2 5.58114 0 9.48114 0C13.3811 0 16.4811 3.2 16.4811 7.1V8C16.4811 9.8 16.9811 11.5 17.9811 12.9L18.5811 13.8C18.8811 14.2 18.8811 14.8 18.6811 15.3Z",
    fill: "#acacac"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38152 21.5C8.68152 21.5 7.88152 21.2 7.48152 20.6C6.98152 20 6.98152 19.1 7.58152 18.6C8.08152 18.1 8.88152 18.1 9.38152 18.5C9.88152 18.1 10.6815 18.1 11.1815 18.6C11.7815 19.1 11.7815 20 11.2815 20.6C10.8815 21.2 10.1815 21.5 9.38152 21.5Z",
    fill: "#acacac"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNotificationBlueInActive);
export default __webpack_public_path__ + "static/media/ico_notification_blue_in_active.bf659b89.svg";
export { ForwardRef as ReactComponent };